export default "/packs/images/default_800x500~9386028a0b5a7fb81ded2252a8bd0b6b.png";